import { createContext } from 'react';

import type { PodcastShow } from '~/services/api/subscription/getShows.server';

/** A podcast show plus the `isActive` flag the element needs (derived from subscription status). */
export type PodcastShowWithActive = PodcastShow & { isActive: boolean };

/**
 * Logic layer for the Podcasts tab — the `PodcastsElement` (the subscriber's podcast shows +
 * "set up app" links). Thin wrapper over `useStaticShows`; reshapes the shows with the
 * subscription-derived `isActive` flag and exposes the podcast-href builder. Holds no UI; the
 * colocated `PodcastsSection` child renders from it.
 */
export type PodcastsContextType = {
  shows: PodcastShowWithActive[];
  hasPodcasts: boolean;
  isLoadingPodcasts: boolean;
  getPodcastHref: (showId: string) => string;
};

export const PodcastsContext = createContext<PodcastsContextType | undefined>(undefined);
PodcastsContext.displayName = 'PodcastsContext';
